/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import { FormControlLabel, Checkbox, Snackbar, Divider} from "@material-ui/core";
import { ReflexContainer,  ReflexElement } from "react-reflex";
import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import TkProcessSelection from "../screens/TkProcessSelection";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import ActionButtonLayout from "../layout/ActionButtonLayout";
import TkSelectionProcessInCreateTempleteDialog from "./TkSelectionProcessInCreateTempleteDialog";
import { debounce } from 'lodash';

const useStyles = makeStyles((theme) => ({

    keepOpenSwitch: {
        marginLeft: "8px"
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text
    },

}));

function TkProcessSelectionDialog ( props ) {

    const {

        id,
        
        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,

        title,
        formId,

        selectItems,
        orderBuyerDetailByProcessGrid,

        ...others

    } = props;

    const  classes = useStyles ();
    const { t } = useTranslation ();

    const [instance, setInstance] = useState ();
    const [createTempleteInstance, setCreateTempleteInstance] = useState();
    const [selectedProcessList, setSelectedProcessList] = useState({});
    const [keepOpen, setKeepOpen] = useState(false);
    const [interaction, setInteraction] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const [createdTempleteId, setCreatedTempleteId] = useState();

    const [processSelectGrid, setProcessSelectGrid] = useState();

    const [templetes, setTempletes] = useState([]);

    useEffect(() => {
            
        if (processSelectGrid) {

            processSelectGrid.selectionChanged.addHandler(debounce((grid, event) => {
                
                const processList = [];

                for(let row of grid.rows) {
                    processList.push(row.dataItem);
                }

                setSelectedProcessList((selectedProcessList)=> {
                    
                    let newFormData = {
                        ...selectedProcessList,
                        processList,
        
                    };
                    return newFormData;
                })
                }, 10)
            );

        }
    }, [processSelectGrid]);

    useEffect(()=> {

        (async()=>{

            let templeteDataList = (await apiClient.get("api/TkBopInProcessTemplete")).data.data;
            const templete = [];

            for(let templeteData of templeteDataList) {

                let key = templeteData.templeteId;

                if(templete[key]) {

                    if(templete[templeteData.templeteId]) {

                        templete[templeteData.templeteId].processCodeList.push(templeteData.processCode);
                    }

                } else {
                    
                    templete[templeteData.templeteId] = {
                        templeteId : templeteData.templeteId,
                        processCodeList : [templeteData.processCode]   
                    };
                }
                
            };

            let filterTemplete = templete.filter((item)=> item !== null && item !== undefined && item !== "" );
            
            setTempletes(filterTemplete);

        })();

    },[createdTempleteId]);

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onNotifySuccess = ( msg ) => {

        notifySuccess ( msg );


    };

    const notifyFailure = (msg) => {

        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onDialogInitialized = ( instance ) => {

        setInstance(instance);

        if ( onInitialized ) {

            onInitialized ( instance );

        }

    };

    const onApiSuccess = (result) => {

        setKeepOpen ( ( keepOpen ) => {

            if ( !keepOpen ) {

                instance.hide();

            }

            if  ( onSuccess ) {

                setTimeout ( ( ) =>  onSuccess ( result.data ), 0 );
    
            } else {

                onNotifySuccess ( result.data );

            }

            return keepOpen;

        } );

    };

    const onApiFailure = (reason) => {

        notifyFailure ( t ( "error.insertFailure", { reason: reason.response ? reason.response.data : JSON.stringify ( reason ) } ) );

    };

    const onOk = ( selectedProcessList ) => {

        let url = `/api/TkOrderBuyerDetailProcess`;
        let apiData = { ...selectedProcessList, orderBuyerDetailList : [...selectItems] };
        let form = new FormData ();

        let json = {};
        let deleted = {};

        for ( const formItem in apiData ) {

            if ( apiData[formItem] !== undefined ) {

                json[formItem] = apiData[formItem];

            }

        }

        form.append ( "deleted", JSON.stringify ( deleted ) );
        form.append ( "json", JSON.stringify ( json ) );
        apiClient
            .post(url, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));

    }

    const onCancel = () => {

        instance.hide();

    };

    const onCreateTempleteDialogInitialized = ( instance ) => {

        setCreateTempleteInstance(instance);

        if ( onInitialized ) {

            onInitialized ( instance );

        }

    };

    const onCreateTempleteClick = () => {
        
        createTempleteInstance.show();

    }

    const checkKeepOpen = () => {

        return (
            <>
                <FormControlLabel
                    control={

                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={ ()=> setKeepOpen( ( keepOpen ) => ( !keepOpen ) ) }
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
                />
                <div style={{flexGrow: 1}}></div>
                <ActionButtonLayout
                    onClick = {()=> onCreateTempleteClick() }
                >
                    
                    {t("buttonName.templeteCreate")}
                </ActionButtonLayout>
            </>

        )

    }

    const onTempleteLoadData = (processList) => {

        let isChecked = processList.some((process)=> process.processSelectionCheck === true)
        setInteraction(isChecked);

    }

    const onCloseNotification = () => {

        setNotification( ( notification ) => {

            return ({...notification, open: false});

        } );

    };

    const onCloseDialog = () => {

        setInteraction(false);
        
        if ( onClose ) {

            onClose ();

        }
    };

    const onCreateTemplete = (templeteId) => {

        setCreatedTempleteId(templeteId)

    };

    const onProcessSelectGridInit = (grid) => {
        
        setProcessSelectGrid(grid);
    }

    return (
        <>
            <Dialog
                id={id}
                moveable={moveable ? moveable : uiConf.dialogMoveable}
                resizable={resizable ? resizable : uiConf.dialogResizable}
                fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
                maxWidth="sm"
                onClose={onCloseDialog}
                onInitialized={onDialogInitialized}
                {...others}
            >

                <DialogHeaderWithClose>
                    <DialogTitle>
                        { title }
                    </DialogTitle>
                </DialogHeaderWithClose>

                <Divider />

                <DialogContent style={{padding: "0px", height: "600px"}}>

                    <ReflexContainer orientation="vertical">
                        <ReflexElement>
                            <TkProcessSelection
                                templeteLoadData = {onTempleteLoadData}
                                onInitialized = {onProcessSelectGridInit}
                                orderBuyerDetailByProcessGrid = {selectItems > 1 ? [] : orderBuyerDetailByProcessGrid}
                                setInteraction ={setInteraction}
                                createdTempleteId = {createdTempleteId}
                                templetes = {templetes}
                            />
                            </ReflexElement>
                    </ReflexContainer>

                    <Snackbar
                        open={notification.open && notification.severity !== "success"}
                        autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                        onClose={onCloseNotification}
                    >
                        <Alert
                            onClose={onCloseNotification}
                            variant="filled"
                            severity={notification.severity}
                        >
                            {notification.msg}
                        </Alert>

                    </Snackbar>

                </DialogContent>

                <Divider />
                
                <DialogActionsOkCancel
                    firstActionComponent={checkKeepOpen}
                    labels={[ t("common.ok")]}
                    buttonDisabled={[!interaction, false]}
                    onOk={() => onOk(selectedProcessList)}
                    onCancel={onCancel}
                />

            </Dialog>

            <TkSelectionProcessInCreateTempleteDialog
                onInitialized = {onCreateTempleteDialogInitialized} 
                onCreateTemplete = {onCreateTemplete}
                onSuccess = {onSuccess}
                processList= {selectedProcessList}
            />
        </>
    );

}

export default TkProcessSelectionDialog;
